import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kc-conversations-filter-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './conversations-filter-tabs.component.html',
  styleUrl: './conversations-filter-tabs.component.scss',
})
export class ConversationsFilterTabsComponent {
  @Input() activeTab: 'attive' | 'recenti' = 'attive';
  @Input() filterDaLeggere: boolean = false;
  @Input() filterDaAccettare: boolean = false;
  @Input() toReadCount: number = 0;
  @Input() toAcceptCount: number = 0;

  @Output() tabChange = new EventEmitter<'attive' | 'recenti'>();
  @Output() filterToggle = new EventEmitter<'da-leggere' | 'da-accettare'>();
}
